<template>
  <div>
    <img class="circle" src="https://www.xaryxx.com/images/circle.png" alt="">
    <div class="names">
      <span>{{title}}</span>{{desc}}
    </div>
    <div class="en">{{en}}</div>
    <!-- <div class="title" :style="{'color': `${color != '' ? color : ''}`}">
        <span>{{title}}</span>
        {{desc}}
        <div class="border-line left" :style="{'backgroundColor': `${color != '' ? color : ''}`}"></div>
        <div class="border-line right" :style="{'backgroundColor': `${color != '' ? color : ''}`}"></div>
      </div> -->
  </div>
</template>

<script>
export default {
  name: "box-title",
  props: {
    title: {
      type: String,
      default: ''
    },
    en: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  // display: flex;

  // justify-content: space-around;
  //   .title {
  //     font-size: 1rem;
  //     flex: 0 1 13rem;
  //     font-weight: 600;
  //     position: relative;
  //     display: table-cell;
  //     vertical-align: bottom;
  //     background-image: linear-gradient(#08cda4, #1bb7cd);
  //     background-clip: text;
  //     -webkit-background-clip: text;
  //     color: transparent;
  //     /*需要文字透明*/

  //     // span {
  //     //   font-size: 2rem;
  //     // }

  //     .border-line {
  //       width: 3rem;
  //       height: .5rem;
  //       border-radius: .25rem;
  //       background-color: #17bbc5;

  //       &.left {
  //         position: absolute;
  //         left: 0;
  //         top: 50%;
  //         transform: translate(-100%, -50%);
  //       }

  //       &.right {
  //         position: absolute;
  //         right: 0;
  //         top: 50%;
  //         transform: translate(100%, -50%);
  //       }
  //     }
  //   }
}

.circle {
  margin: 72px 0 35px 0;
}

.names {
  // padding-top: 30px;
  font-size: 30px;
  font-family: PingFang SC-Semibold, PingFang SC;

  color: #333333;

  span {
    font-weight: 600;
  }
}

.en {
  font-size: 30px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #C6C6C6;
  // line-height: 42px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/box-title.vue